module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921105649_T.fda0a037.jpg";